import axiosConfig from "./axiosConfig";

class MentionService {
    async getAll() {
        try {
            const response = await axiosConfig.get("/mention");
            return response.data || [];
        } catch (error) {
            console.error("Error fetching mentions:", error);
            return [];
        }
    }

    async create(formData) {
        try {
            const response = await axiosConfig.post("/mention", formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la création:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async update(id, formData) {
        try {
            const response = await axiosConfig.patch(`/mention/${id}`, formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la mise à jour:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async delete(id) {
        try {
            const response = await axiosConfig.delete(`/mention/${id}`);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la suppression:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }
}

const MentionServiceInstance = new MentionService();
export default MentionServiceInstance;